import { appStore, defaultWatchingList } from "../../common/store/AppStore"
import _ from 'lodash'
import { observable, autorun } from "mobx"
import Constants from "../../common/constants/Constants"
import { getRequest } from "../../common/helpers/RequestHelper"
import HttpStatusCode from "../../common/constants/HttpErrorCode"
import { IShortCompanyInfo } from "../../common/model/Model"
class DashboardStore {
    handleRemoveModuleClick(id: number) {

        let data = _.cloneDeep(appStore.localDashboardConfig)
        data.workSpaces.map((item) => {
            if (item.id === appStore.localDashboardConfig.lastWorkSpaceId) {
                item.config.map((c, i) => {
                    if (c.id === id) {
                        item.config.splice(i, 1)
                    }
                })
            }
        })
        appStore.localDashboardConfig = data
        
    }
    @observable autoPlay: boolean = true
    @observable edit: boolean = false
    @observable listShortCompanyInfo: IShortCompanyInfo[] = []
    @observable showListCompanyInfoModal: boolean = false
    @observable keySearch: string = ""
    @observable listCompanyMath: IShortCompanyInfo[] = []
    handleMoveUpStockSymbol(index: number) {
        if (appStore.watchingList) {
            let current = appStore.watchingList[index]
            let before = appStore.watchingList[index - 1]
            if (before) {
                appStore.watchingList[index - 1] = current;
                appStore.watchingList[index] = before
            }
            this.saveLocalConfig()
        }
    }
    handleMoveDownStockSymbol(index: number) {
        if (appStore.watchingList) {
            let current = appStore.watchingList[index]
            let after = appStore.watchingList[index + 1]
            if (after) {
                appStore.watchingList[index + 1] = current;
                appStore.watchingList[index] = after
            }
            this.saveLocalConfig()
        }
    }
    handleRemoveStockSymbol(index) {
        if (appStore.watchingList) {
            appStore.watchingList.map((item, i) => {
                if (i === index) {
                    appStore.watchingList?.splice(i, 1)
                }
            })
            this.saveLocalConfig()
            this.checkShowControlButton()
        }
    }
    saveLocalConfig() {
        if (appStore.watchingList) {
            let config: string[] = []
            appStore.watchingList.map((item) => {
                config.push(item.stockSymbol)
            })
            localStorage.setItem(Constants.TVSI_DASHBOARD_WATCHING_LIST, JSON.stringify(config))
        }
    }
    async getListCompanyShortInfo() {
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'GetListCompanyShortInfo')
        if (result.status < HttpStatusCode.CODE_300) {
            this.listShortCompanyInfo = result.body
        }
    }
    handleChageInputSearch(key: string) {
        this.keySearch = key
        if (key) {
            this.showListCompanyInfoModal = true
            this.listShortCompanyInfo.map((item) => {
                if (item.value.toUpperCase().indexOf(key.toUpperCase()) > -1) {
                    item.isHide = false
                }
                else item.isHide = true
            })
            let t = _.cloneDeep(this.listShortCompanyInfo)
            t.sort((a, b) => {
                if (a.value.toLowerCase().indexOf(key.toLowerCase()) > b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return 1;
                } else if (a.value.toLowerCase().indexOf(key.toLowerCase()) < b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return -1;
                } else {
                    if (a.value > b.value)
                        return 1;
                    else
                        return -1;
                }
            });
            this.listShortCompanyInfo = t
        }
        else {
            this.showListCompanyInfoModal = false
        }
    }
    async handleAddStockSymbolClick(item: IShortCompanyInfo) {
        let data = localStorage.getItem(Constants.TVSI_DASHBOARD_WATCHING_LIST)
        let listCompany: string[] = []
        if (data) {
            JSON.parse(data).map((item) => {
                listCompany.push(item)
            })
            listCompany.push(item.stockSymbol)
        }
        else {
            defaultWatchingList.map((item) => {
                listCompany.push(item)
            })
            listCompany.push(item.stockSymbol)
        }
        localStorage.setItem(Constants.TVSI_DASHBOARD_WATCHING_LIST, JSON.stringify(listCompany))
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'GetListTopStockHeader?stockSymbol=' + item.stockSymbol)
        if (result.status < HttpStatusCode.CODE_300 && appStore.watchingList) {
            let symbol = {
                "stockSymbol": item.stockSymbol,
                "value": item.value,
                "basicPrice": 0,
                "ceilingPrice": 0,
                "floorPrice": 0,
                "matchPrice": 0,
                "matchQtty": 0,
                "matchValue": 0,
                "totalTradingQtty": 0,
                "totalTradingValue": 0,
                "percentChange": result.body.percentChange
            }
            appStore.watchingList.push(symbol)
            this.checkShowControlButton()
        }
        appStore.regisShortStockInfo()
        this.showListCompanyInfoModal = false
        this.keySearch = ""
    }
    async removeAllWatchingList() {
        const result = window.confirm('Bạn có muốn xóa toàn bộ mã đang theo dõi')
        if (result === true) {
            appStore.watchingList = []
            localStorage.setItem(Constants.TVSI_DASHBOARD_WATCHING_LIST, "[]")
            this.edit = false
            this.checkShowControlButton()
        }
        

    }
    @observable isShowControl: boolean = true
    checkShowControlButton() {
        let value = Math.round(window.innerWidth / 220 - 2)
        if (appStore.watchingList && appStore.watchingList.length > value) {
            this.isShowControl = true
        }
        else {
            this.isShowControl = false
        }
    }
}
export const dashboardStore = new DashboardStore()